import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LayoutComponent } from './layout';
import { HomeComponent } from './home';
import { ClientsComponent, GrantComponent } from './clients';
import { ProfileComponent } from './profile';
import { KeywordListComponent, KeywordDetailComponent, AffiliateListComponent, AffiliateDetailComponent, KeywordAdvanceComponent } from './keyword';
import { MoRecordComponent } from './mo-record';
import { DnRecordComponent } from './dn-record';
import { SubscriberComponent } from './subscriber';
import { MoLogComponent } from './mo-log';
import { DnLogComponent } from './dn-log';
import { ClientSubscriberComponent } from './subscriber-client';
import { ClientMoLogComponent } from './mo-log-client';
import { ClientDnLogComponent } from './dn-log-client';
import { DnChargeComponent, DnPerformanceComponent, SubscriptionPerformanceComponent, RetentionComponent, MoQualityAssessmentComponent, MultipleSubComponent, DnChargeScComponent, SummaryScheduleListComponent, SubscriptionPerformanceDetailComponent } from './report';
import { AuthGuard } from '../_helpers';
import { ContentListComponent, ContentDetailComponent, EpisodeListComponent, EpisodeDetailComponent } from './tx-content';
import { TxKeywordListComponent, TxKeywordDetailComponent } from './tx-keyword';
import { ScMsgListComponent, ScMsgDetailComponent, KwMsgListComponent, KwMsgDetailComponent } from './tx-message';
import { ScheduleSupportComponent, TxKeywordSupportComponent, MsgTemplateSupportComponent, ResourceSupportComponent, ThirdPartyNotesSupportComponent } from './support';
import { TxMoLogComponent } from './tx-mo-log';
import { TxMtLogComponent } from './tx-mt-log';
import { TxSubscriberComponent } from './tx-subscriber';
import { SmsCountComponent } from './report/sms-count/sms-count.component';
import { StreamHistoryComponent, StreamHistoryReportComponent, StreamKeywordDetailComponent, StreamKeywordGuideComponent, StreamKeywordListComponent } from './stream';
import { SpiderAccountDetailComponent, SpiderAcountListComponent, SpiderScheduleListComponent } from './spider';
import { PremiumServiceMetaListComponent } from './premium-service';
import { DnRevenueCompatibleComponent, DnRevenueComponent, PayoutReportComponent, PayoutUploadComponent, RevenueShareRatioComponent } from './revenue';
import { PayoutRecordListComponent } from './revenue/payout/records-list/payout-record-list.component';
import { AdvertiserAffiliateDetailComponent, AdvertiserAffiliateListComponent, AdvertiserDetailComponent, AdvertiserListComponent, OfferStreamHistoryComponent } from './offer-stream';

const routes: Routes = [
  {
    path: 'dashboard',
    component: LayoutComponent,
    canActivate: [AuthGuard],
    children: [
      { path: '', redirectTo: 'home', pathMatch: 'full' },
      { path: 'home', component: HomeComponent, data: { animation: 'fadeIn' } },
      { path: 'clients', component: ClientsComponent },
      { path: ':id/grant', component: GrantComponent },
      { path: 'profile', component: ProfileComponent },
      { path: 'keyword', component: KeywordListComponent },
      { path: 'keyword-advance', component: KeywordAdvanceComponent },
      { path: 'keyword-detail/:id', component: KeywordDetailComponent },
      { path: 'keyword/:id/affiliate', component: AffiliateListComponent },
      { path: 'affiliate-detail/:id', component: AffiliateDetailComponent },
      { path: 'mo-record', component: MoRecordComponent },
      { path: 'dn-record', component: DnRecordComponent },
      { path: 'dn-charge', component: DnChargeComponent },
      { path: 'dn-charge-sc', component: DnChargeScComponent },
      { path: 'dn-performance', component: DnPerformanceComponent },
      { path: 'revenue/report', component: DnRevenueComponent },
      { path: 'revenue/report-compatible', component: DnRevenueCompatibleComponent },
      { path: 'subscription-performance', component: SubscriptionPerformanceComponent },
      { path: 'subscription-performance-detail', component: SubscriptionPerformanceDetailComponent },
      { path: 'retention', component: RetentionComponent },
      { path: 'mo-quality-assessment', component: MoQualityAssessmentComponent },
      { path: 'subscriber', component: SubscriberComponent },
      { path: 'mo-log', component: MoLogComponent },
      { path: 'dn-log', component: DnLogComponent },
      { path: 'c/subscriber', component: ClientSubscriberComponent },
      { path: 'c/mo-log', component: ClientMoLogComponent },
      { path: 'c/dn-log', component: ClientDnLogComponent },
      { path: 'tx/content', component: ContentListComponent },
      { path: 'tx/content-detail/:id', component: ContentDetailComponent },
      { path: 'tx/content/:id/episode', component: EpisodeListComponent },
      { path: 'tx/episode-detail/:id', component: EpisodeDetailComponent },
      { path: 'tx/keyword', component: TxKeywordListComponent },
      { path: 'tx/keyword-detail/:id', component: TxKeywordDetailComponent },
      { path: 'tx/sc-msg', component: ScMsgListComponent },
      { path: 'tx/sc-msg-detail/:id', component: ScMsgDetailComponent },
      { path: 'tx/kw-msg/:id', component: KwMsgListComponent },
      { path: 'tx/kw-msg-detail/:id', component: KwMsgDetailComponent },
      { path: 'support/schedule', component: ScheduleSupportComponent },
      { path: 'support/tx-kw', component: TxKeywordSupportComponent },
      { path: 'support/msg-template', component: MsgTemplateSupportComponent },
      { path: 'support/res-list', component: ResourceSupportComponent },
      { path: 'tx/mo-log', component: TxMoLogComponent },
      { path: 'tx/mt-log', component: TxMtLogComponent },
      { path: 'tx/subscriber', component: TxSubscriberComponent },
      { path: 'support/3rdparty', component: ThirdPartyNotesSupportComponent },
      { path: 'sms-count', component: SmsCountComponent },
      { path: 'stream/keyword', component: StreamKeywordListComponent },
      { path: 'stream/keyword-guide', component: StreamKeywordGuideComponent },
      { path: 'stream/keyword-detail/:id', component: StreamKeywordDetailComponent },
      { path: 'stream/history', component: StreamHistoryComponent },
      { path: 'stream/report', component: StreamHistoryReportComponent },
      { path: 'multi-sub', component: MultipleSubComponent },
      { path: 'spider/account', component: SpiderAcountListComponent },
      { path: 'spider/account-detail/:id', component: SpiderAccountDetailComponent },
      { path: 'spider/schedule', component: SpiderScheduleListComponent },
      { path: 'summary/schedule', component: SummaryScheduleListComponent },
      { path: 'premium-service/meta', component: PremiumServiceMetaListComponent },
      { path: 'revenue/payout/report', component: PayoutReportComponent },
      { path: 'revenue/payout/upload', component: PayoutUploadComponent },
      { path: 'revenue/payout/records', component: PayoutRecordListComponent },
      { path: 'revenue/share-ratio', component: RevenueShareRatioComponent },
      { path: 'offer-stream/advertiser', component: AdvertiserListComponent },
      { path: 'offer-stream/advertiser/:id', component: AdvertiserDetailComponent },
      { path: 'offer-stream/advertiser/:id/affiliate', component: AdvertiserAffiliateListComponent },
      { path: 'offer-stream/advertiser/:id/affiliate/:affId', component: AdvertiserAffiliateDetailComponent },
      { path: 'offer-stream/history', component: OfferStreamHistoryComponent },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DashboardRoutingModule { }
